import { useState } from 'react';
import { useIsJobCoach } from '@App/components/AuthProvider/auth-provider.context';
import { useNavigate, useLocation, matchRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useScrollAtBottom } from '@services/hooks.service';
import { Button, Icon } from '@nazka/nazka.mapframe.components';
import { faArrowDown, faRectanglePro, faSlidersH } from '@fortawesome/pro-solid-svg-icons';
import {
  faArrowUp, faList, faPrint, faSpinnerThird, 
} from '@fortawesome/pro-regular-svg-icons';
import Print from '@utils/Print/Print';

import routes from '@App/app.routes';

import './actions-menu.styl'

function ActionsMenu() {
  const navigate = useNavigate();
  const location = useLocation();
  const matches = matchRoutes(routes, location.pathname);
  const actions = matches[matches.length - 1]?.route?.actions || [];
  const routeTitle = matches[matches.length - 1]?.route?.title || '';
  const [printNow, setPrintNow] = useState(false);
  
  const isJobCoach = useIsJobCoach();
  const allVacancies = useSelector(state => state.map.allVacancies);
  const breakpoint = useSelector(state => state.windowObserver.breakpoint);

  const isAtBottom = useScrollAtBottom(document.querySelector('.shared-base__container'));
  
  return (
    <div className="actions-menu">
      {actions.includes('filter') && (
        <Button
          icon={faSlidersH}
          layout="ghost"
          hover={false}
          onClick={() => {
            navigate('/vacatures/filter');
            window.gtag?.('event', 'vacancies_click_filter_button', {
              event_category: 'Vacancies',
              event_label: 'Click filter button',
            });
            document.querySelector('.shared-base__container__left')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="actions-menu__action"
        >
          Filter
        </Button>
      )}
      {isJobCoach && actions.includes('print') && (
        <Button
          icon={printNow ? faSpinnerThird : faPrint}
          layout="ghost"
          hover={false}
          onClick={() => {
            setPrintNow(true);
            window.gtag?.('event', 'vacancies_click_print_button', {
              event_category: 'Vacancies',
              event_label: 'Click print button',
            });
          }}
          className={`actions-menu__action${printNow ? '--loading' : ''}`}
        >
          <span>Print</span>
          {printNow && (<Print setPrintNow={setPrintNow} />)}
          <Icon icon={faRectanglePro} className="actions-menu__action__pro" />
        </Button>
      )}
      {!!allVacancies.length && actions.includes('list') && (
        <Button
          icon={faList}
          layout="ghost"
          hover={false}
          onClick={() => {
            navigate('/vacatures');
            document.querySelector('.shared-base__container__left')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="actions-menu__action"
        >
          Lijst
        </Button>
      )}
      {breakpoint?.maxWidth <= 767 && (
        <Button
          icon={isAtBottom ? faArrowUp : faArrowDown}
          layout="ghost"
          hover={false}
          onClick={() => {
            if (isAtBottom) {
              document.querySelector('.shared-base__container').scrollTo({ top: 0, behavior: 'smooth' });
            } else {
              document.querySelector('.shared-base__container__left')?.scrollIntoView({ behavior: 'smooth' });
            }
          }}
          className="actions-menu__action"
        >
          {!isAtBottom && routeTitle}
          {isAtBottom ? 'Kaart' : ''}
        </Button>
      )}
    </div>
  );
}

export default ActionsMenu;